import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';
// tslint:disable-next-line
register('product-detail-slider', () => import(/* webpackMode: "lazy" */'./product-detail-slider'));
